// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3uclK","signatureBlock":"Footer_signatureBlock__3yHDi","signature":"Footer_signature__1Cm6l"};